export type PadlockIconProps = {
  className?: string;
};

export function PadlockIcon({ className }: PadlockIconProps) {
  return (
    <svg
      aria-label="Padlock"
      className={className}
      fill="none"
      height="58"
      role="img"
      viewBox="0 0 52 58"
      width="52"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.875 20.125H38.6693V11.5C37.9437 5.04908 32.5171 0 25.875 0C19.2329 0 13.8086 5.04908 13.0827 11.5L13.0807 20.125H2.875C1.28599 20.125 0 21.4124 0 23V54.625C0 56.2126 1.28599 57.5 2.875 57.5H48.875C50.464 57.5 51.75 56.2126 51.75 54.625V23C51.75 21.4124 50.464 20.125 48.875 20.125ZM18.8307 11.5C19.4985 8.22336 22.4029 5.75 25.875 5.75C29.3471 5.75 32.2495 8.22336 32.9173 11.5L32.9193 20.125H18.8307V11.5ZM46 51.75H5.75V25.875H46V51.75Z"
        fill="currentColor"
      />
      <path
        d="M23.7188 39.652V43.9869C23.7188 45.1775 24.6845 46.1432 25.875 46.1432C27.0655 46.1432 28.0312 45.1775 28.0312 43.9869V39.652C29.3149 38.9051 30.1875 37.5297 30.1875 35.9375C30.1875 33.5558 28.2567 31.625 25.875 31.625C23.4933 31.625 21.5625 33.5558 21.5625 35.9375C21.5625 37.5297 22.4351 38.9051 23.7188 39.652Z"
        fill="currentColor"
      />
    </svg>
  );
}
